// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1VGSE","footer":"ModalInfo_footer__1QffR"};